export default {
  misc: {
    ok: 'Ok',
    cancel: 'Cancel',
    feed: 'Feed',
  },
  login: {
    identifierPlaceholder: 'Your email',
    passwordPlaceholder: 'Your password',
    title: 'Log in',
    signInButtonText: 'Submit',
  },
  projectContext: {
    placeholder: 'Select project',
  },
  problems: {
    problem: 'Problem',
    problemTitle: 'Problem title',
    createdThisProblem: '{{firstName}} {{lastName}} created this problem',
    createProblem: 'Create Problem',
    viewInDetail: 'View in details',
    selectProject: 'Select a project',
    view: 'View',
    newProblem: 'New problem',
    writeDescription: 'Write or paste the description of the problem here...',
    title: 'Problems',
    archiveButtonText: 'Archive',
    confirmButtonText: 'Validate problem',
    dragRejectText: 'The file must be a jpeg',
    dragAcceptText: 'Release to drop',
    releaseToDropText: 'Drag & Drop a file',
  },
  solutions: {
    counting: {
      one: '1 solution',
      other: '{{count}} solutions',
      zero: '0 solutions',
    },
    solution: 'Solution n°',
    solutionTitle: 'Solution title',
    writeDescription: 'Write or paste the description of the solution here...',
    createdThisSolution: '{{firstName}} {{lastName}} created this solution',
    createSolution: 'Create Solution',
    newSolution: 'New solution',
    nextStep: 'Next step',
    exploreSolutions: 'Explore Solutions',
    startProject: 'Start a project',
    youHave: 'You have',
    viewSolutions: 'View solutions',
    solution0: 'Solutions - 0',
    solutions: 'Solutions',
    addSolution: 'Add a solution',
    proposeFirstSolution: 'Propose your first solution',
    proposeSolution: 'Propose a solution',
    getProposal: 'Get a proposal',
    seeDetails: 'See details',
    dismiss: 'Dismiss',
  },
  archives: {
    title: 'Archives',
    archiveButtonText: 'Remove from archives',
  },
  submitProblemView: {
    switchImage: 'Switch Image',
    browseToUpload: 'Browse to Upload',
    title: 'Submit problem',
    selectProject: 'Select project',
    selectProjectPlaceholder: 'Select project',
    noProjectSelected: 'No project selected',
    selectCurrentFrame: 'Load selected frame',
    refreshCurrentFrame: 'Load selected frame',
  },
  billing: {
    openPortalButtonText: 'Open billing portal',
    chooseSubscriptionPlan: 'Choose a subscription plan',
    pricing: {
      month: '{{formattedAmount}} per month',
    },
  },
  chrome: {
    selectedProject: 'Selected project:',
    selectAProject: 'Select a project',
    addProblem: 'Add Problem',
    addProblemOverlayTitle: 'Add a problem',
  },
}
